<template>
  <div class="table-action-wrapper design-assign" ref="container">
    <div class="position-relative d-flex w-100">
      <Select source="template/search" field="order" placeholder="Template" v-model="templateId" class="flex-1 mr-2"></Select>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center">
        <span>Confirm</span>
      </a>
    </div>
  </div>
</template>
<script>
import { utils, writeFileXLSX } from 'xlsx'
export default {
  data() {
    return {
      templateId: null
    }
  },
  computed: {
    store() {
      return this.config?.store
    },
    query() {
      return this.store.getter('query', {})
    }
  },
  methods: {
    exportToXlsx(data) {
      let workbook = utils.book_new()
      Object.entries(data).forEach(([, sheet]) => {
        let data = [
          sheet.columns.map((item) => {
            return item.title
          })
        ]
        let worksheet = utils.aoa_to_sheet(data.concat(sheet.data))
        utils.book_append_sheet(workbook, worksheet, sheet.name)
      })
      writeFileXLSX(workbook, `File-${new Date().getTime()}.xlsx`)
    },
    async submit() {
      let query = Object.assign(
        _.reduce(
          this.query,
          (result, item, key) => {
            let value = _.isObjectLike(item) ? item?.value : item
            if (value) {
              result[key] = value
            }
            return result
          },
          {}
        ),
        {
          type: 'order',
          template_id: this.templateId
        }
      )

      let response = null
      let page = 0
      let data = {}
      do {
        page += 1
        query.page = page
        response = await this.$util.get('template/export/order', query, this.$refs.container)
        if (response.status == 'success') {
          if (Object.keys(data.items || []).length == 0) {
            data = response.data
          } else {
            data.items = data.items.concat(response.data.items)
          }
        }
      } while (response?.data?.items?.length == 100)
      if (data.items.length > 0) {
        this.exportOrder(Object.values(data.template.meta.data || []), Object.values(data.items))
      }
    },
    exportOrder(columns, items) {
      let colIndexs = []
      columns.forEach((colVal, colKey) => {
        colVal = Object.assign(
          {
            field: ''
          },
          colVal
        )
        if (colVal.field.toLowerCase().replace(/\s*/g, '') == 'line_items>attributes') {
          colIndexs.push(colKey)
        } else {
          columns[colKey].field = colVal.field.toLowerCase().replace(/\s*/g, '')
        }
      })

      let attributes = {}
      items.forEach((item) => {
        Object.entries(item).forEach(([orderKey, order]) => {
          if (orderKey == 'line_items') {
            item.line_items.forEach((line_item) => {
              Object.entries(line_item).forEach(([key, value]) => {
                if (key == 'attributes') {
                  let combinedAttribute = []
                  Object.entries(line_item.attributes).forEach(([attributeKey, attribute]) => {
                    if (attributes[attributeKey.toLowerCase().replace(/\s*/g, '')] == undefined) {
                      attributes[attributeKey.toLowerCase().replace(/\s*/g, '')] = {
                        title: attributeKey,
                        field: `line_items>attributes>${attributeKey.toLowerCase().replace(/\s*/g, '')}`
                      }
                    }
                    combinedAttribute.push(`${attributeKey}:\n${attribute}`)
                    line_item[`attributes>${attributeKey.toLowerCase().replace(/\s*/g, '')}`] = attribute
                  })
                  line_item['combined_attribute'] = combinedAttribute.join("\n")
                } else {
                  line_item[key.toLowerCase().replace(/\s*/g, '')] = value
                }
              })
            })
          } else {
            item[orderKey.toLowerCase().replace(/\s*/g, '')] = order
          }
        })
      })

      if (colIndexs.length > 0) {
        colIndexs.sort(function (a, b) {
          return b - a
        })
        colIndexs.forEach((colIndex) => {
          columns.splice(colIndex, 1)
          columns.splice(colIndex, 0, ...Object.values(attributes))
        })
      }

      let sheet = {
        name: 'Sheet 1',
        columns: columns,
        data: []
      }

      items.forEach((item) => {
        let rows = [[]]
        Object.entries(item).forEach(([k, v]) => {
          item[k.toLowerCase().replace(/\s*/g, '')] = v
        })
        columns.forEach((column) => {
          column = Object.assign(
            {
              field: ''
            },
            column
          )
          if (column.field.indexOf('line_items') != -1) {
            let firstIndex = rows[0].length
            let field = column.field.replace('line_items>', '')
            item.line_items.forEach((line_item, index) => {
              if (!_.isArray(rows[index])) {
                rows[index] = Array(firstIndex).fill('')
              }
              rows[index].push(line_item[field] || '')
            })
          } else {
            rows[0].push(item[column.field] || '')
          }
        })
        sheet.data = sheet.data.concat(rows)
      })
      this.exportToXlsx([sheet])
    }
  },
  props: {
    config: Object
  }
}
</script>
